/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios"
import { useEffect, useState } from "react"
import toast from "react-hot-toast"
import ContextContainer from "../ContextContainer"
import { ContextMenuItem } from "../ui/context-menu"
import { MdRefresh } from "react-icons/md"

type Quote = {
  "text": "string",
  "author": "string",
  "tags": [
    "string"
  ],
  "id": 0,
  "author_id": "string"
}

function QuoteWidget() {

  const [fetchingQuote, setFetchingQuote] = useState(true)
  const [quote, setQuotes] = useState<null | Quote>(null)

  const fetchQuote = async () => {

    if (!fetchingQuote) setFetchingQuote(true)

    try {
      const res = await axios.get("https://thequoteshub.com/api/random-quote?format=json")

      if (!res.data) {
        toast.error("Something went wrong while fetching random quote")
        return
      }

      setQuotes(res.data)

    } catch (error) {
      console.log(error)
    } finally {
      setFetchingQuote(false)
    }
  }

  useEffect(() => {
    fetchQuote()
  }, [])

  return (
    <ContextContainer
      trigger={

        <div>
          {fetchingQuote ? (
            <div className="w-full relative p-4 bg-zinc-200/85 dark:bg-zinc-800/90 space-y-2 rounded-lg">
              <p className="bg-zinc-700/80 rounded-md animate-pulse h-4 w-full"></p>
              <p className="bg-zinc-700/80 rounded-md animate-pulse h-4 w-5/6"></p>
            </div>
          ) : quote ? (
            <div className="w-full relative p-4 bg-zinc-200/85 dark:bg-zinc-800/90 rounded-lg">
              <p className="italic min-h-24">"{quote.text}"</p>
              <div className="h-10"></div>
              <span className="absolute bottom-4 right-4">----- {quote.author}</span>
            </div>
          ) : (
            <div className="w-full group flex justify-between items-center py-2 px-3 bg-zinc-200/70 dark:bg-zinc-800/70">
              No quote found
            </div>
          )}
        </div>
      }>
      <ContextMenuItem disabled={fetchingQuote} onClick={() => fetchQuote()}>
        <MdRefresh className="text-lg" />
        <span className="ml-3">Refresh quote</span>
      </ContextMenuItem>
    </ContextContainer>
  )
}

export default QuoteWidget